import "../styles/components/HeroSection.css";
import heroImage from "../assets/hero.jpg";
import heroMobileImage from "../assets/hero-mobile.jpg";

export default function HeroSection() {
  return (
    <header
      className="hero"
      aria-label="Conference hero"
      style={{
        "--hero-image-desktop": `url(${heroImage})`,
        "--hero-image-mobile": `url(${heroMobileImage})`,
      }}
    >
      <div className="container hero__inner">
        <div className="hero__content">
          <div className="hero__kicker">
            2026 MOËT HENNESSY
            <br />
            DISTRIBUTOR CONFERENCE
          </div>

          <h1 className="hero__title">FUTURE FORWARD</h1>

          <p className="hero__subtitle">
            JOIN INDUSTRY LEADERS FOR THREE DAYS OF INSIGHTS,
            <br />
            NETWORKING, AND INNOVATION
          </p>

          <div className="hero__rule" aria-hidden="true" />

          <div className="hero__meta" aria-label="Dates and location">
            <div className="hero__metaLine">MARCH 10-12</div>
            <div className="hero__metaLine">CHICAGO, IL</div>
          </div>

          <div className="hero__rule hero__rule--after" aria-hidden="true" />

          <div className="hero__brand">
            <div className="hero__logo" aria-label="Moët Hennessy USA">
              <div className="hero__logoName">Moët Hennessy</div>
              <div className="hero__logoSub">USA</div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
